export enum TriggerQueueState {
    Waiting,
    Queued,
    Running
}
